import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ApproachSection from './components/ApproachSection';
import DoorsSection from './components/DoorsSection';
import WhoSection from './components/WhoSection';
import FounderSection from './components/FounderSection';
import DoubtsSection from './components/DoubtsSection';
import ContactSection from './components/ContactSection';
import AffiliationsSection from './components/AffiliationsSection';
import Footer from './components/Footer';
import AdminAccess from './components/AdminAccess';
import Analytics from './components/Analytics';
import ComplaintsPage from './pages/ComplaintsPage';
import AdminPanel from './pages/AdminPanel';
import CRMPage from './pages/CRMPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

const LandingPage = () => (
  <>
    <Navigation />
    <main id="top">
      <HeroSection />
      <ApproachSection />
      <DoorsSection />
      <WhoSection />
      <FounderSection />
      <DoubtsSection />
      <ContactSection />
    </main>
    <AffiliationsSection />
    <Footer />
    <AdminAccess />
  </>
);

const LegalLayout = ({ children }) => (
  <>
    <Navigation />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App" data-testid="app-container">
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: '#17140d',
                border: '1px solid rgba(212,175,55,.18)',
                color: '#f5f2eb',
                fontFamily: '"IBM Plex Mono", ui-monospace, Consolas, monospace',
                fontSize: '13px',
              },
            }}
          />
          <Analytics />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/complaints" element={<LegalLayout><ComplaintsPage /></LegalLayout>} />
            <Route path="/privacy-policy" element={<LegalLayout><PrivacyPolicyPage /></LegalLayout>} />
            <Route path="/terms-of-service" element={<LegalLayout><TermsOfServicePage /></LegalLayout>} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/crm" element={<CRMPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
